<template>
  <div class="nkn-node-software">
    <div class="common-sub-title">{{$t("miner.software.title")}}</div>
    <div class="software-module">

      <div class="software-miner">
        <div class="software-miner-header">
          <img v-lazy="'/static/img/miner/nodeSoftware/GUI.png'" class="pic-miner-GUI">
        </div>
        <div class="common-thrid-title">{{$t("miner.software.subtitle1")}}</div>
        <!--<download-module :href="$url.DOWNLOAD_MINER.github">
          <img v-lazy="'/static/img/miner/nodeSoftware/github.png'" slot="download-icon" class="icon-miner-github">
          <span slot="download-btn">{{$t("miner.software.githubBtn")}}</span>
        </download-module>-->
        <div class="common-thrid-title">
          <ul>
            <li class="common-fourth-title">{{$t("miner.software.tutorial")}}</li>
            <li class="common-fourth-link">
              <a v-if="lang === 'zh'" href="https://forum.nkn.org/t/pc-windows-mac-linux/1624" target="_blank">{{$t("miner.software.pcMining")}}</a>
              <a v-else href="https://forum.nkn.org/t/windows-gui-mining-support-both-32-and-64-bits/1608" target="_blank">{{$t("miner.software.pcMining")}}</a>
              <download-module :href="$url.DOWNLOAD_MINER.github">
                <span slot="download-btn">{{$t("miner.software.githubBtn")}}</span>
              </download-module>
            </li>

          </ul>
        </div>
      </div>

      <div class="software-release">
        <div class="software-release-header clearfix">
          <div class="first-col">
            <div class="pic-container">
              <a :href="$url.PARTNER.googleCloud" target="_blank">
                <img v-lazy="'/static/img/miner/nodeSoftware/googlecloud.png'" class="pic-miner-googlecloud">
              </a>
            </div>
            <div class="pic-container">
              <a :href="$url.PARTNER.AWS" target="_blank">
                <img v-lazy="'/static/img/miner/nodeSoftware/AWS.png'" class="pic-miner-AWS">
              </a>
            </div>
          </div>
          <div class="center-col">
            <div class="pic-container">
              <a :href="$url.PARTNER.DigitalOcean" target="_blank">
                <img v-lazy="'/static/img/miner/nodeSoftware/DigitalOcean.png'" class="pic-miner-DigitalOcean">
              </a>
            </div>
            <div class="pic-container">
              <a>
                <img v-lazy="'/static/img/miner/nodeSoftware/linux.png'" class="icon-miner-linux">
              </a>
            </div>
          </div>
          <div class="last-col">
            <div class="pic-container">
              <a>
                <img v-lazy="'/static/img/miner/nodeSoftware/Raspipng.png'" class="pic-miner-Raspipng">
              </a>
            </div>
            <div class="pic-container">
              <a>
                <img v-lazy="'/static/img/miner/nodeSoftware/router.png'" class="pic-miner-router">
              </a>
            </div>
          </div>
        </div>
        <div class="common-thrid-title">{{$t("miner.software.subtitle2")}}</div>
        <!--<download-module :href="$url.DOWNLOAD_MINER.github">
          <img v-lazy="'/static/img/miner/nodeSoftware/github.png'" slot="download-icon" class="icon-miner-github">
          <span slot="download-btn">{{$t("miner.software.githubBtn")}}</span>
        </download-module>-->
        <div class="common-thrid-title">
          <a href="https://forum.nkn.org/t/nkn-mining-guide-for-mainnet-wiki-version/1720" target="_blank" class="link">{{$t("miner.software.nknMiningFAQ")}}</a>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import DownloadModule from '@/components/miner/plugins/DownloadModule'

  export default {
    components: {
      DownloadModule
    },
  computed: {
  ...mapState({
      lang: state=>state.lang.lang
    })
  },
  }
</script>

<style lang="scss" scoped>
  .nkn-node-software {
    @include common-inner();

    .common-thrid-title {
      font-size: 16px;
      font-weight: 300;
      margin-bottom: 20px;
      @media screen and (max-width: 768px) {
        font-size: 1rem;
      }
    }

    .software {
      &-module {
        display: flex; flex-wrap: wrap;
        padding: 2rem 0;
        @include nkn-bg-img($url: linear-gradient(180deg, #c2c5cc 0, #c2c5cc), $size: 1px auto, $clip: content-box);

        @media screen and (max-width: 768px) {
          background: none;
        }
      }

      &-miner {
        width: 50%; padding-left: 20px; padding-right: 20px;
        @media screen and (max-width: 768px) {
          margin-bottom: 40px;width: 100%;
        }

        &-header {
          text-align: center;
          padding: 20px 0;
          height: 280px;
          padding-top: 52px;
        }

        .download-module {
          text-align: center; margin-left: 1rem;
          display: inline-block;
        }
      }

      &-release {
        width: 50%;padding-left: 50px;padding-right: 20px;
        @media screen and (max-width: 768px) {
          width: 100%;padding-left: 20px;
        }
        &-header {
          margin-left: auto; margin-right: auto;
          padding: 20px 0;
          width: 315px;
          height: 280px;
          @media screen and (max-width: 768px) {
            height: 230px; margin-left: auto; margin-right: auto;
          }
          box-sizing: border-box;
          text-align: center;
          line-height: 6rem;

          .first-col,
          .center-col {
            float: left;
          }

          .center-col {
            margin-left: 1rem;
          }

          .last-col {

          }
        }

        .download-module {
          margin-top: 2rem;
          margin-bottom: 2rem;
        }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/miner/nknNodeSoftware.vue